import { checkIsValid } from 'pages/MyAccount/utils/date';
import forEach from 'lodash/forEach';

export const characterLimits = {
  HEXCODE: 8,
  XSMALL: 251,
  SMALL: 501,
  MEDIUM: 1001,
  LARGE: 3001,
  XLARGE: 10001,
};

export const handleValidation = (e, setError, clearErrors, ...validations) => {
  const { name, value } = e.target;
  clearErrors(name);
  if (value) {
    forEach(validations, (validate) => {
      validate(e, setError);
    });
  }
};

export const validateCharacterLimit = (e, setError) => {
  const { maxLength, name, value } = e.target;
  if (value.length > maxLength - 1) {
    setError(name, {
      type: 'character limit',
      message: `You have reached the ${(maxLength - 1)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} character limit.`,
    });
  }
};

export const validateHexcode = (e, setError) => {
  const { value, name } = e.target;
  const isValid = /^#[0-9A-F]{6}$/i.test(value);
  if (!isValid) {
    setError(name, {
      type: 'validation',
      message: 'Please enter a valid hexcode.',
    });
  }
};

export const validateDate = (e, setError) => {
  const { value, name } = e.target;
  const isValid = checkIsValid(value);
  if (!isValid) {
    setError(name, {
      type: 'validation',
      message: 'Please enter a valid date.',
    });
  }
};

export const validateUrl = (e, setError) => {
  const { value, name } = e.target;
  // eslint-disable-next-line max-len
  const isValid =
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/.test(
      value,
    );
  if (!isValid) {
    setError(name, {
      type: 'validation',
      message: 'Please enter a valid url.',
    });
  }
};

export const validateBannerImage = (image) =>
  new Promise((resolve) => {
    let error;
    if (image && image.size > 500000) {
      error = {
        title: 'Background Image Update Failed',
        subtitle: 'Image size is over 500KB. Please reduce the image weight and try again.',
      };

      resolve(error);
    }
    const img = new Image();
    img.onload = () => {
      if (img.width < 2880 || img.height < 800) {
        error = {
          title: 'Background Image Update Failed',
          subtitle: 'Image must be at least 2,880 pixels wide by 800 pixels tall.',
        };
      }
      resolve(error);
    };
    img.src = image && window.URL.createObjectURL(image);
  });
